import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-multi-dropdown',
  templateUrl: './multi-dropdown.component.html',
  styleUrls: ['./multi-dropdown.component.scss'],
})
export class MultiDropdownComponent {
  @Input() items: any[] = [];
  @Input() disabled: boolean = false;
  @Input() placeholder: string = 'Select';

  @Output() itemSelected = new EventEmitter<any>();

  isOpen = false;
  selectedItem: any = null;
  openSubmenus: { [key: string]: boolean } = {};

  constructor(){
    this.items
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectItem(item: any, event: Event) {
    event.stopPropagation(); // Prevents closing the dropdown on submenu item selection

    if (item.sub && item.sub.length > 0) {
      // If the item has a submenu, toggle the submenu visibility
      console.log(this.openSubmenus[item.keyName]);
      this.openSubmenus[item.keyName] = !this.openSubmenus[item.keyName];
      this.selectedItem = item;
    } else {
      // Select the item and close the dropdown
      this.selectedItem = item;
      this.isOpen = false;
      this.itemSelected.emit(item);
      this.selectedItem = null
    }
  }

  isActive(item: any): boolean {
    return (
      this.selectedItem &&
      (this.selectedItem === item ||
        item.sub?.some((subItem: any) => subItem === this.selectedItem))
    );
  }

  @ViewChild('menu', { static: true }) menu: ElementRef;
  buttonLabel: boolean = true; // Default label is "Scroll to Bottom"
  lastDirection: 'top' | 'bottom' = 'bottom'; // Track the last scroll direction

  // Handle the scroll event and update the button label
  checkScroll(): void {
    const scrollTop = this.menu.nativeElement.scrollTop;
    const scrollHeight = this.menu.nativeElement.scrollHeight;
    const offsetHeight = this.menu.nativeElement.offsetHeight;

    const isAtTop = scrollTop === 0;
    const isAtBottom = scrollTop + offsetHeight >= scrollHeight - 1; // Allow a small buffer for floating-point precision

    // Update the button label based on scroll position
    if (isAtTop) {
      this.buttonLabel = true;
      this.lastDirection = 'bottom';
    } else if (isAtBottom) {
      this.buttonLabel = false;
      this.lastDirection = 'top';
    }
  }

  // Function to handle button click
  scroll(): void {
    if (this.lastDirection === 'bottom') {
      this.scrollToBottom();
    } else {
      this.scrollToTop();
    }
  }

  // Scroll to the top
  scrollToTop(): void {
    this.menu.nativeElement.scrollTop = 0;
    this.buttonLabel = true;
    this.lastDirection = 'bottom'; // After scrolling to the top, change the direction to bottom
  }

  // Scroll to the bottom
  scrollToBottom(): void {
    this.menu.nativeElement.scrollTop = this.menu.nativeElement.scrollHeight;
    this.buttonLabel = false;
    this.lastDirection = 'top'; // After scrolling to the bottom, change the direction to top
  }
}